module.exports = __webpack_public_path__ + "img/topback.8cc77317.png";